import React from "react";

import { Skeleton as AntSkeleton } from "antd";

/**
 * @param    {type} type "block" | "paragraph" | "title"
 * @param    {height} height Sets the height of the Skeleton from type block
 * @param    {width} width Sets the width of the Skeleton from type title or paragraph
 * @param    {rows} rows Sets the number of rows (only for paragraph and title type)
 * @param    {buttonSize} buttonSize Sets the size of the Skeleton from type button
 * @param    {buttonShape} buttonShape Sets the shape of the Skeleton from type button
 * @param    {className} className Class name
 * @returns Skeleton or children
 */
export const Skeleton = ({ height, width, rows, type, buttonSize, buttonShape, className = "" }) => {
  const titleProps = {
    paragraph: {
      rows: 0,
    },
    title: {
      width: width || "50%",
    },
    active: true,
  };

  const paragraphProps = {
    paragraph: {
      rows: rows || 2,
    },
    title: false,
    active: true,
    style: {
      width: width || "100%",
    },
  };

  const blockProps = {
    style: {
      width: width || "100%",
      height: height || "200px",
    },
    active: true,
  };

  const buttonProps = {
    size: buttonSize,
    shape: buttonShape,
    active: true,
  };

  const skeletonProps = {
    block: blockProps,
    paragraph: paragraphProps,
    title: titleProps,
    button: buttonProps,
  };

  if (type === "block") {
    return <AntSkeleton.Input {...skeletonProps[type]} className={className} />;
  }

  if (type === "button") {
    return <AntSkeleton.Button {...skeletonProps[type]} className={className} />;
  }

  return <AntSkeleton {...skeletonProps[type]} className={className} />;
};

export default Skeleton;
